import { render, staticRenderFns } from "./EstablishmentViewEquipments.vue?vue&type=template&id=5ac31f36"
import script from "./EstablishmentViewEquipments.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewEquipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports